const VisualStatic = require('visual-static');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['employer_name', 'employer_address_one', 'employer_address_two', 'employer_city', 'employer_state', 'employer_zip', 'employer_phone', 'employee_name', 'employee_address_one', 'employee_address_two', 'employee_city', 'employee_state', 'employee_zip', 'employee_id', 'check_number', 'employee_ssn', 'start_date', 'end_date', 'pay_date', 'regular_r', 'regular_hr', 'regular_current', 'regular_ytd', 'overtime_r', 'overtime_hr', 'overtime_current', 'overtime_ytd', 'other_r', 'other_hr', 'other_current', 'other_ytd', 'medicare_current', 'medicare_ytd', 'ss_current', 'ss_ytd', 'federal_current', 'federal_ytd', 'state_current', 'state_ytd', 'other_deduct_current', 'other_deduct_ytd', 'current_gross_total', 'ytd_gross_total', 'current_deductions_total', 'ytd_deductions_total', 'current_net_pay', 'ytd_net_pay'];

    this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();

    // Set the correct order of fields
    VisualStatic.setTabOrder(this.orderOfFormFields);

    // Remove labels (they are basically duplicates)
    VisualStatic.setPlaceholders(this.removeLabelsFromFields);

    // For older browsers use our POLYFILL to add the appropriate placeholders
    $('input').placeholder();

    VisualStatic.initExportPDF();

    $('form #group_other_current').eq(1).addClass('copy');
    $('form #group_other_ytd').eq(1).addClass('copy');
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-employee-paystub.js